import { render, staticRenderFns } from "./DeleteFrameworkConfirm.vue?vue&type=template&id=7f6b82f2"
import script from "./DeleteFrameworkConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteFrameworkConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports